module.exports = __webpack_public_path__ + "static/media/hiso-bus-rental-blank-profile-picture.6732bd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hiso-bus-rental-blank-profile-picture.png
// module id = 360
// module chunks = 57